module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFwAAAAFCAQAAABiZ0PsAAAASklEQVQoFdXBwRWCQAwFwF/JRui/BAUP1hEflQwHqshMEuX0yhDK155EafxVBlAalz3eHp8M4PD4xdJolQEsjcuWRDlVhrActuQGlAdCs58GRX8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Flourishes/fork_spoon_flyer_diamonds.png
// module id = 1575
// module chunks = 1